import styled from "styled-components";

export const TabledRowText = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: flex-start;
`;

export const TabledHeaderButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-transform: inherit;
  cursor: pointer;

  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 3px; }
`;

export const SortDirection = styled.span`
  display: inline-block;
  color: ${p => p.active ? p.theme.palette.blue.main : p.theme.palette.colors.subdued};
  font-size: 15px;
  line-height: 1;
  transform: rotate(${p => p.descending ? '180deg' : '0deg'});
  transition: transform 0.2s ease;

  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
